export default "__VITE_ASSET__BvJ1DTzH__"